import React, { useCallback, useEffect, useState } from "react";
import { Container, Box } from "@material-ui/core";
import { useGetData, usePutData } from "hooks";
import useStore from "context";
import * as Api from "service/index";
import { useTranslation } from "localization/translation";
import { TermForm } from "./item";
import Button from "@material-ui/core/Button";


const TermsAndConditions = () => {
  const [data, , refresh] = useGetData(Api.terms.getAll);
  const updateCallback = usePutData(Api.terms.update, refresh);
  const { setRemove } = useStore();
  const [disabledAddNewItemButton, setDisabledAddNewItemButton] = useState(false);
  const [terms, setTerms] = useState([]);
  const translation = useTranslation();

  useEffect(() => {
    if(data?.data) {
      setTerms(data.data);
    } else {
      setTerms([]);
    }
  }, [data]);

  useEffect(() => {
    if(terms?.length > 0) {
      const lastItem = terms[terms.length - 1];
      if(!lastItem?.id) {
        setDisabledAddNewItemButton(true);
      } else {
        setDisabledAddNewItemButton(false);
      }
    }
  }, [terms]);

  const addNewItem = () => {
    const newItem = {
      title_en: "",
      title_ru: "",
      title_hy: "",
      text_en: "",
      text_ru: "",
      text_hy: "",
    };
    setTerms((st) => [...st, newItem]);
    setDisabledAddNewItemButton(true);

  }

  const handleDeleteItem = (id) => {
    if(id) {
      setRemove(() => () =>
        Api.terms.delete(id).then(refresh)
      )
    } else {
      setTerms((st) => st.filter((item) => item.id !== id));
    }
  };

  return (
    <Container>
      <Box className="d-flex align-items-center justify-content-end mb-4">
        <Button
          className="m-2 btn-neutral-primary"
          onClick={addNewItem}
          disabled={disabledAddNewItemButton}
        >
          {translation.add_new_item}
        </Button>
      </Box>
      {
        terms?.map((item) => (
          <TermForm
            key={item.id}
            initialData={item}
            onSave={updateCallback}
            onDeleteItem={() => handleDeleteItem(item.id)}
          />
        )) || null
      }
    </Container>
  );
};

export default TermsAndConditions;
